import React from 'react';
import { Alert } from '@sainsburys-tech/bolt';

var Error = function Error() {
  var ALERT_MSG = "Oops, something's gone wrong. We're working hard to fix it... please try again later.";
  return /*#__PURE__*/React.createElement(Alert, {
    kind: "error",
    isCloseable: false
  }, ALERT_MSG);
};

export default Error;